import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { SectionIconWrapper } from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { AnimatePresence, motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

import { usePaymentForm } from "../PaymentFormContext";

export default function AuthIcon() {
  const {
    state: { user, isMobile },
  } = usePaymentPage();

  const {
    state: { formStages },
  } = usePaymentForm();

  const [previousStateHadPhoto, setPreviousStateHadPhoto] = useState(
    user?.photoURL && user?.loginLevel === "full"
  );
  const [backgroundColor, setBackgroundColor] = useState(
    formStages.auth === "isFullyLoggedIn" ? colors.fnPurple : null
  );

  useEffect(() => {
    setPreviousStateHadPhoto(user?.photoURL);
  }, [user?.photoURL]);

  useEffect(() => {
    setBackgroundColor(
      (formStages.amount === "complete" &&
        formStages.auth === "requestCode" &&
        !isMobile) ||
        ["isFullyLoggedIn", "verifyCode", "skipped"].includes(formStages.auth)
        ? colors.fnPurple
        : null
    );
  }, [formStages.auth, formStages.amount, isMobile]);

  const hideIcon =
    isMobile && ["requestCode", "verifyCode"].includes(formStages.auth);

  return (
    <IconWrapper
      initial={{
        width: hideIcon ? 0 : 74,
        opacity: hideIcon ? 0 : 1,
      }}
      animate={{
        width: hideIcon ? 0 : 74,
        opacity: hideIcon ? 0 : 1,
      }}
    >
      <IconPadding>
        <SectionIconWrapper style={{ backgroundColor, marginRight: 0 }}>
          <AnimatePresence>
            {user?.photoURL && user?.loginLevel === "full" && (
              <UserPhoto
                key="user_photo"
                initial={{
                  opacity: previousStateHadPhoto ? 1 : 0,
                  scale: previousStateHadPhoto ? 1 : 0.6,
                  y: 0,
                }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ y: "-100%", opacity: 0, transition: { type: "tween" } }}
                style={{ backgroundImage: `url(${user.photoURL})` }}
              />
            )}
            {((!user?.photoURL && user?.loginLevel === "full") ||
              ["untouched", "skipped", "requestCode", "verifyCode"].includes(
                formStages.auth
              )) && (
              <IconElementContainer
                key="icon"
                initial={{
                  opacity: previousStateHadPhoto ? 0 : 1,
                  y: previousStateHadPhoto ? "100%" : 0,
                }}
                animate={{ opacity: 1, y: 0, transition: { delay: 0.1 } }}
                exit={{ y: "-100%", opacity: 0, transition: { type: "tween" } }}
              >
                <FnrIcon fas fa-user />
              </IconElementContainer>
            )}
          </AnimatePresence>
        </SectionIconWrapper>
      </IconPadding>
    </IconWrapper>
  );
}

const UserPhoto = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;
const IconElementContainer = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconWrapper = styled(motion.div)`
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
  display: flex;
  justify-content: flex-end;
`;
const IconPadding = styled.div`
  padding: 14px;
  padding-right: 0;
`;
